import React from 'react';
import { Table, Row, Col, Button, Menu, Dropdown, Pagination } from 'antd';
import { CloseCircleOutlined, SettingOutlined, DownCircleOutlined, EditOutlined } from '@ant-design/icons';

import { getParamTable, _tableLogActivity } from '../../../../lib/Helper';

class Desktop extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    };
  }

  componentDidMount() {
    this.props.fetchTable()
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action

    return (
      <>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Table
              columns={[
                {
                  title: 'No',
                  dataIndex: 'rownum',
                  width: '2%',
                },
                {
                  title: 'Guru Ekstra',
                  dataIndex: 'nama_lengkap',
                  render: (a, row) => <>{(row.nama_lengkap ? row.nama_lengkap : "-")}</>
                },
                {
                  title: 'Kelas',
                  dataIndex: 'rombel_nama',
                  render: (a, row) => row.rombel_nama ? row.rombel_nama: "-"
                },
                {
                  title: 'Ekstrakurikuler',
                  dataIndex: 'ekstrakurikuler_nama',
                  render: (a, row) => row.ekstrakurikuler_nama ? row.ekstrakurikuler_nama: "-"
                },
                {
                  title: 'Nilai S1',
                  dataIndex: 'nilai_semester_ganjil',
                  render: (a, row) => row.nilai_semester_ganjil ? row.nilai_semester_ganjil: "-"
                },
                {
                  title: 'Nilai S2',
                  dataIndex: 'nilai_semester_genap',
                  render: (a, row) => row.nilai_semester_genap ? row.nilai_semester_genap: "-"
                },
                {
                  title: 'Tahun Ajaran',
                  dataIndex: 'tahun_ajaran',
                  render: (a, row) => row.tahun_ajaran ? row.tahun_ajaran: "-"
                },
                {
                  title: <SettingOutlined />,
                  align: "center",
                  key: 'operation',
                  width: '2%',
                  render: (a, row) => (!action.delete && !action.update ? "-" : <Dropdown trigger={['click']} menu={<Menu>
                    {action.update ? (<Menu.Item key={1} onClick={this.props.modalForm.bind(this, true, row)}><EditOutlined /> Update Nilai</Menu.Item>) : ""}
                    {action.delete ? (<Menu.Item key={2} onClick={this.props.modalDelete.bind(this, true, row)}><CloseCircleOutlined /> Delete</Menu.Item>) : ""}
                  </Menu>}>
                    <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                  </Dropdown>),
                },
                {
                  title: 'LogActivity',
                  key: 'operation',
                  width: '10%',
                  render: (a, row) => _tableLogActivity(row),
                },
              ]}
              rowKey={record => record.id}
              dataSource={table.data}
              pagination={false}
              loading={table.loading}
              size="small"
            />
          </Col>
          <Col xs={24} className="table-pagination">
            <Pagination
              size="small"
              current={table.pagination.current}
              pageSize={table.pagination.pageSize}
              total={table.pagination.total}
              showTotal={() => `Total ${table.pagination.total} items`}
              showSizeChanger
              onChange={(current, pageSize) => {
                const pagination = { current: current, pageSize: pageSize, total: table.pagination.total }
                const params = getParamTable("change", table, null, null, pagination)
                this.props.fetch(params)
              }}
            />
          </Col>
        </Row>
      </>
    )
  }
}

export default Desktop;
